import React from 'react';

const DatePickerContext = React.createContext(null);

export default DatePickerContext;



// WEBPACK FOOTER //
// ./src/lib/DatePickerContext/index.js